import { render, staticRenderFns } from "./EyeHealthPage.vue?vue&type=template&id=11cf2049&scoped=true&"
import script from "./EyeHealthPage.vue?vue&type=script&lang=js&"
export * from "./EyeHealthPage.vue?vue&type=script&lang=js&"
import style0 from "./EyeHealthPage.vue?vue&type=style&index=0&id=11cf2049&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cf2049",
  null
  
)

export default component.exports